export default __webpack_public_path__ + "static/media/Project302MasterPlanNew.50653f83.webp";